export type PrivateEventLocationMode = 'venue' | 'client-site' | 'tbd';

/** `default` zones follow the state or region; a `manual` pick is never overwritten. */
export type TimeZoneSource = 'default' | 'manual';

export interface PrivateEventFormFields {
  regionId: string;
  locationMode: PrivateEventLocationMode;
  venueId: string;
  locationName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipCode: string;
  /** IANA zone. In the form's view this is the effective zone: the manual pick,
   *  or the default for the state / region while the source is `default`. */
  timeZone: string;
  timeZoneSource: TimeZoneSource;
  workshopTypeId: string;
  date: string;
  startTime: string;
  /** Edit only: the day the event ends, which differs from `date` overnight. */
  endDate: string;
  endTime: string;
  clientName: string;
  headcount: string;
  dealValue: string;
  hubspotDealId: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  addOns: string[];
  notes: string;
}

export const DEFAULT_DEAL_VALUE = '2400';

export const EMPTY_FIELDS: PrivateEventFormFields = {
  regionId: '',
  locationMode: 'venue',
  venueId: '',
  locationName: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zipCode: '',
  timeZone: '',
  timeZoneSource: 'default',
  workshopTypeId: '',
  date: '',
  startTime: '18:00',
  endDate: '',
  endTime: '20:00',
  clientName: '',
  headcount: '',
  dealValue: DEFAULT_DEAL_VALUE,
  hubspotDealId: '',
  contactName: '',
  contactEmail: '',
  contactPhone: '',
  addOns: [],
  notes: '',
};
